import React from "react";
import TabSection from "./tab_section/TabSection";
import ExperiencePower from "./experience_power/ExperiencePower";

export default function GallaryShowcase() {
  return (
    <div>
      <TabSection />
      <ExperiencePower />
    </div>
  );
}
